import type { AdminStats } from "@storyline/shared";
import { unwrap } from "@/src/common/services/api-error";
import { httpClient, request } from "@/src/common/services/http.service";

export const getAdminStats = async (): Promise<AdminStats> => unwrap(await request(() => httpClient.admin.stats.get()));
